import ApiService from "./ApiService";

const DictionaryStatsService = {

    /**
     * Get dictionary statistics from API
     * @returns {Promise<Object>} Object containing total words and today's word count
     */
    getDictionaryStats: async () => {
        try {
            const result = await ApiService.getData("/v1/stats/dic/overview");
            return result;
        } catch (error) {
            console.error("Error fetching dictionary stats:", error);
            throw error;
        }
    }
};

export default DictionaryStatsService;

